"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _IMAGE$HEIC$VIDEO$AUD,
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _fileTypes = require("./fileTypes"),
    _default = (_IMAGE$HEIC$VIDEO$AUD = {}, (0, _defineProperty2["default"])(_IMAGE$HEIC$VIDEO$AUD, _fileTypes.IMAGE, "image"), (0, _defineProperty2["default"])(_IMAGE$HEIC$VIDEO$AUD, _fileTypes.HEIC, "apple"), (0, _defineProperty2["default"])(_IMAGE$HEIC$VIDEO$AUD, _fileTypes.VIDEO, "projects"), (0, _defineProperty2["default"])(_IMAGE$HEIC$VIDEO$AUD, _fileTypes.AUDIO, "audio"), (0, _defineProperty2["default"])(_IMAGE$HEIC$VIDEO$AUD, _fileTypes.FONT, "typography"), (0, _defineProperty2["default"])(_IMAGE$HEIC$VIDEO$AUD, _fileTypes.OTHER, "document"), _IMAGE$HEIC$VIDEO$AUD);

exports["default"] = _default;